import { ImportHistoryInterface } from "../../../../domains/ImportHistory";
import SectionInterface from "../../../../interfaces/SectionInterface";
import ImportOperation from "../ImportOperation";
import ImportOperationForEntryGuide from "../ImportOperationForEntryGuide";
import { ImportOperationForStudentPasscodeInactivationPage } from "../ImportOperationForStudentPasscodeInactivation";

interface Props {
  importOperation: ImportHistoryInterface["operation"];
  section: SectionInterface;
}

export const ImportOperationRouter = ({ importOperation, section }: Props) => {
  switch (importOperation) {
    case "entry_guides_for_students":
    case "entry_guides_for_guardians":
      return (
        <ImportOperationForEntryGuide
          section={section}
          operation={importOperation}
        />
      );
    case "student_passcode_inactivation":
      return (
        <ImportOperationForStudentPasscodeInactivationPage
          section={section}
          operation={importOperation}
        />
      );
    default:
      return <ImportOperation section={section} operation={importOperation} />;
  }
};
